const formElement: HTMLFormElement|null = document.querySelector('.js-form');
const uploadElements: NodeListOf<HTMLElement> = document.querySelectorAll('.m-item-fineuploader.js-upload');

export async function initFormSubmitHandler() {
  if (!formElement) {
    return;
  }

  formElement.addEventListener('submit', (e) => {
    let valid = true;

    /* check all the upload fields if an image was uploaded + check if checkbox is checked */
    uploadElements.forEach((uploadElement) => {
      let uploadList = uploadElement.querySelector('.qq-upload-list');
      if (!uploadList) {
        return;
      }
      /* check if there are uploaded images */
      if (uploadList.hasChildNodes()) {
        let container: HTMLElement|null = uploadList.closest('.form__box');
        if (!container) {
          return;
        }
        let checkbox: HTMLInputElement|null = container.querySelector('.js-required');
        if (!checkbox) {
          return;
        }
        if (!checkbox.checked) {
          valid = false;
          checkbox.scrollIntoView({behavior: 'smooth'});
        }
      }
    });

    if (!valid) {
      e.preventDefault();
    }
  });
}
